import WeightedAverageInterface from "@app/Interface/WeightedAverageInterface";
import axios from "@app/Security/AxiosAuthentication";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class WeightedAverageHelper {

    static getAverages = async (controller: AbortController, fpuId: number, pageId: number): Promise<WeightedAverageInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.WEIGHTED_AVERAGES + `?page=1&fpu_id=${fpuId}&page_id=${pageId}`;

        const url = baseUrl + endPoint;

        return await axios.get(url, {
            withCredentials: true,
            signal: controller.signal
        })
            .then(response => {

                const components: WeightedAverageInterface[] = response.data["hydra:member"];

                return components;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "getAverages()");
                
                // return an empty set of navItems
                const emptyItems: Array<WeightedAverageInterface> = [];

                return emptyItems;

            });

    }

    /**
     * Tries to find records from todays date or later.
     * @param rows 
     * @returns 
     */
    static getRecordByToday = (rows: WeightedAverageInterface[]): WeightedAverageInterface => {

        const emptyItem: WeightedAverageInterface = {
            ProducerID: 0,
            MonthYear_PK: new Date(),
            Weight: 0,
            Fat: 0,
            Protein: 0,
            Lactose: 0,
            SNF: 0,
            Leuc: 0,
            OtherSolids: 0,
            AshFactor: 0,
            MUN: 0
        };

        let weightedAverageItem = emptyItem;

        if (rows.length) {

            const currentDate = new Date();

            // NOTE: month is based on index values!
            const thresholdDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

            const filteredRows = rows.filter(row => row.MonthYear_PK >= thresholdDate);

            if (filteredRows.length) {
                weightedAverageItem = filteredRows[0];
            } else {
                // fall back to the first record
                weightedAverageItem = rows[0];
            }
        }

        return weightedAverageItem;

    }

}